import React, { Component } from "react";
import DeviceIdentifier from 'react-device-identifier';
import Image from 'react-bootstrap/Image'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import './../content/css/general.css';
import './../content/css/header.css';
import './../content/css/responsive.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

import logo from '../content/img/emlak-mortgage-logo.png';
import icon1 from '../content/img/question.png';
import icon2 from '../content/img/_x30_8_home.png';
import icon3 from '../content/img/contract.png';
import icon4 from '../content/img/handshake.png';


class Header extends Component {
  constructor(props) {
    super(props);

    this.openDesktopMenu = this.openDesktopMenu.bind(this);
    this.state = {
        open: false,
        isTop: true,
        activeEventKey: "0"
    };
  }

  componentDidMount() {
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 50;
      if (isTop !== this.state.isTop) {
          this.setState({ isTop })
      }
    });
  }

  openDesktopMenu() {
    const currentState = this.state.open;
    this.setState({ open: !currentState });
  }

  render() {
    return (
      <>
        <DeviceIdentifier isDesktop={true}>
          <header className={`${this.state.isTop ? 'notScrolled' : 'scrolled'} DesktopMenu ${this.state.open ? ' megaMenuActive' : ''}`}>
            <Navbar className="mortgageNavbar" fixed="top" collapseOnSelect expand="lg" bg={this.state.isTop ? 'transparent' : 'light'} variant="light">
                <Container>
                    <Nav.Link className="menuOpenButton" onClick={this.openDesktopMenu}>
                      <div className={this.state.open ? 'navIcon open' : 'navIcon'}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <b>MENÜ</b>
                    </Nav.Link>
                    <Navbar.Brand href="/"><Image src={logo} alt="Emlak Katılım Logo" width="240" /></Navbar.Brand>
                    <Nav className="ml-auto">
                        <Nav.Link href="/neden-biz">Neden Biz?</Nav.Link>
                        <Nav.Link href="/anlasmali-konut-projeleri">Anlaşmalı Projeler</Nav.Link>
                        <Nav.Link href="/urun-ve-hizmet-ucretleri">Ürün ve Hizmet Ücretleri</Nav.Link>
                        <Form inline>
                            <Button variant="primary" target="_blank" type="button" href="https://emlakkatilim.com.tr/tr/musteri-ol">MÜŞTERİ OL</Button>
                        </Form>
                    </Nav>
                </Container>
            </Navbar>
            
            <div className="megaMenu" style={{paddingTop: "80px"}}>
              <Container className="mt-4 pt-5 border-top">
                  <Row>
                      <Col md={3} className="text-center">
                          <Image className="mb-4" src={icon1} alt="Neden Biz" />
                          <Nav className="flex-column pt-2">
                              <h3>Neden Biz</h3>
                              <Nav.Link href="/neden-biz">Hakkımızda</Nav.Link>
                              <Nav.Link href="/sss">Sıkça Sorulan Sorular</Nav.Link>
                              <Nav.Link href="/bize-ulasin">Bize Ulaşın</Nav.Link>
                          </Nav>
                      </Col>
                      <Col md={3} className="text-center">
                          <Image className="mb-4" src={icon2} alt="Mortgage Hakkında" />
                          <Nav className="flex-column pt-2">
                            <h3>Mortgage Hakkında</h3>
                              <Nav.Link href="/mortgage/mortgage-sozlugu">Mortgage Sözlüğü</Nav.Link>
                              <Nav.Link href="/mortgage/mortgage-kanunu">Mortgage Kanunu</Nav.Link>
                              <Nav.Link href="/mortgage/ozellikler">Finansman Özellikleri</Nav.Link>
                              <Nav.Link href="/mortgage/finansman-sureci">Mortgage Nasıl Çalışır?</Nav.Link>
                              <Nav.Link href="/mortgage/sozlesmeler-ve-formlar">Sözleşmeler Formlar</Nav.Link>
                          </Nav>
                      </Col>
                      <Col md={3} className="text-center">
                          <Image className="mb-4" src={icon3} alt="Finansman Seçenekleri" />
                          <Nav className="flex-column pt-2">
                            <h3>Finansman Seçenekleri</h3>
                              <Nav.Link href="/konut-finansman-urunlerimiz/yeni-evini-bekletmeyen-konut-finansmani">Yeni Evini Bekletmeyen Mortgage</Nav.Link>
                              <Nav.Link href="/konut-finansman-urunlerimiz/konut-finansmani">Konut Finansmanı</Nav.Link>
                              <Nav.Link href="/konut-finansman-urunlerimiz/kentsel-donusum">Kentsel Dönüşüm</Nav.Link>
                              <Nav.Link href="/konut-finansman-urunlerimiz/birlikte-konut-finansmani">Birlikte Konut Finansmanı</Nav.Link>
                              <Nav.Link href="/konut-finansman-urunlerimiz/memlekette-konut-finansmani">Memlekette Konut Finansmanı</Nav.Link>
                              <Nav.Link href="/konut-finansman-urunlerimiz/yabanci-yatirimcilar-icin-vatandaslik">Yabancı Yatırımcılar için Vatandaşlık</Nav.Link>

                          </Nav>
                      </Col>
                      <Col md={3} className="text-center">
                          <Image className="mb-4" src={icon4} alt="Anlaşmalar" />
                          <Nav className="flex-column pt-2">
                              <h3>Anlaşmalı Projeler</h3>
                              <Nav.Link href="/anlasmali-konut-projeleri">Tüm Projeler</Nav.Link>
                              <Nav.Link href="/anlasmali-konut-projeleri?st=1">İnşaatı Devam Eden Projeler</Nav.Link>
                              <Nav.Link href="/anlasmali-konut-projeleri?st=2">İnşaatı Biten Projeler</Nav.Link>
                          </Nav>
                      </Col>
                  </Row>
              </Container>
            </div>
          </header>
        </DeviceIdentifier>
        <DeviceIdentifier isMobile={true} isTablet={true}>
          <header className={`${this.state.isTop ? 'notScrolled' : 'scrolled'} MobileMenu ${this.state.open ? ' megaMenuActive' : ''}`}>
            <Navbar className="mortgageNavbar p-0" fixed="top" collapseOnSelect expand="lg" bg={this.state.isTop ? 'transparent' : 'light'} variant="light">
                <Container className="mb-2">
                    <Button className="mb-3" variant="primary" target="_blank" type="button" href="https://emlakkatilim.com.tr/tr/musteri-ol">MÜŞTERİ OL</Button>
                    <Navbar.Brand className="ml-4" href="/"><Image src={logo} alt="Emlak Katılım Logo" width="240" /></Navbar.Brand>
                    <Nav className="ml-auto">
                      <Nav.Link className="mr-4" onClick={this.openDesktopMenu}>
                        <div className={this.state.open ? 'navIcon open' : 'navIcon'}>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
            
            <div className="megaMenu" style={{paddingTop: "155px"}}>
              <Accordion defaultActiveKey="0">
                <Card {...(this.state.activeEventKey === "0" && { className: "activeAccordionHeader" })}>
                  <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.setState({ activeEventKey: "0" })}>
                    <h3>Neden Biz?
                    <FontAwesomeIcon className="IconUp float-right" icon={faChevronUp} />
                    <FontAwesomeIcon className="IconDown float-right" icon={faChevronDown} /></h3>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <Nav.Link href="/neden-biz">Hakkımızda</Nav.Link>
                      <Nav.Link href="/sss">Sıkça Sorulan Sorular</Nav.Link>
                      <Nav.Link href="/bize-ulasin">Bize Ulaşın</Nav.Link>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card {...(this.state.activeEventKey === "1" && { className: "activeAccordionHeader" })}>
                  <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => this.setState({ activeEventKey: "1" })}>
                    <h3>Mortgage Hakkında
                    <FontAwesomeIcon className="IconUp float-right" icon={faChevronUp} />
                    <FontAwesomeIcon className="IconDown float-right" icon={faChevronDown} /></h3>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <Nav.Link href="/mortgage/mortgage-sozlugu">Mortgage Sözlüğü</Nav.Link>
                      <Nav.Link href="/mortgage/mortgage-kanunu">Mortgage Kanunu</Nav.Link>
                      <Nav.Link href="/mortgage/ozellikler">Finansman Özellikleri</Nav.Link>
                      <Nav.Link href="/mortgage/finansman-sureci">Mortgage Nasıl Çalışır?</Nav.Link>
                      <Nav.Link href="/mortgage/sozlesmeler-ve-formlar">Sözleşmeler Formlar</Nav.Link>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card {...(this.state.activeEventKey === "2" && { className: "activeAccordionHeader" })}>
                  <Accordion.Toggle as={Card.Header} eventKey="2" onClick={() => this.setState({ activeEventKey: "2" })}>
                    <h3>Finansman Seçenekleri
                    <FontAwesomeIcon className="IconUp float-right" icon={faChevronUp} />
                    <FontAwesomeIcon className="IconDown float-right" icon={faChevronDown} /></h3>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <Nav.Link href="/konut-finansman-urunlerimiz/yeni-evini-bekletmeyen-konut-finansmani">Yeni Evini Bekletmeyen Mortgage</Nav.Link>
                      <Nav.Link href="/konut-finansman-urunlerimiz/konut-finansmani">Konut Finansmanı</Nav.Link>
                      <Nav.Link href="/konut-finansman-urunlerimiz/kentsel-donusum">Kentsel Dönüşüm</Nav.Link>
                      <Nav.Link href="/konut-finansman-urunlerimiz/birlikte-konut-finansmani">Birlikte Konut Finansmanı</Nav.Link>
                      <Nav.Link href="/konut-finansman-urunlerimiz/memlekette-konut-finansmani">Memlekette Konut Finansmanı</Nav.Link>
                      <Nav.Link href="/konut-finansman-urunlerimiz/yabanci-yatirimcilar-icin-vatandaslik">YABANCI YATIRIMCILAR İÇİN VATANDAŞLIK</Nav.Link>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card {...(this.state.activeEventKey === "3" && { className: "activeAccordionHeader" })}>
                  <Accordion.Toggle as={Card.Header} eventKey="3" onClick={() => this.setState({ activeEventKey: "3" })}>
                    <h3>Anlaşmalı Projeler
                    <FontAwesomeIcon className="IconUp float-right" icon={faChevronUp} />
                    <FontAwesomeIcon className="IconDown float-right" icon={faChevronDown} /></h3>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body>
                      <Nav.Link href="/anlasmali-konut-projeleri">Tüm Projeler</Nav.Link>
                      <Nav.Link href="/anlasmali-konut-projeleri?st=1">İnşaatı Devam Eden Projeler</Nav.Link>
                      <Nav.Link href="/anlasmali-konut-projeleri?st=2">İnşaatı Biten Projeler</Nav.Link>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </header>
        </DeviceIdentifier>
      </>
    );
  }
}

export default Header;